export const invitationActionTypes = {
  ACCEPT_INVITATION: 'user/ACCEPT_INVITATION',
  ACCEPT_INVITATION_PENDING: 'user/ACCEPT_INVITATION_PENDING',
  ACCEPT_INVITATION_SUCCESS: 'user/ACCEPT_INVITATION_SUCCESS',
  ACCEPT_INVITATION_FAILED: 'user/ACCEPT_INVITATION_FAILED',
  ACCEPT_INVITATION_CLEANUP: 'user/ACCEPT_INVITATION_CLEANUP',

  GET_INVITATION_DETAILS: 'user/GET_INVITATION_DETAILS',
  GET_INVITATION_DETAILS_PENDING: 'user/GET_INVITATION_DETAILS_PENDING',
  GET_INVITATION_DETAILS_SUCCESS: 'user/GET_INVITATION_DETAILS_SUCCESS',
  GET_INVITATION_DETAILS_FAILED: 'user/GET_INVITATION_DETAILS_FAILED',
  GET_INVITATION_DETAILS_CLEANUP: 'user/GET_INVITATION_DETAILS_CLEANUP',

  SET_INVITATION_DATA: 'user/SET_INVITATION_DATA',
};
